<app-icon-button
    *ngIf="viewport.phone$ | async"
    [style.justify-self]="'flex-end'"
    [title]="addToOrRemoveFromCartTitle$ | async"
    [placeholder]="showPlaceholders || (servicesInfoLoaded$ | async) !== true"
    (click)="toggleAccountInCart()"
    [disabled]="!(accountIsPayable$ | async)"
    [spinner]="updatingCartState$ | async"
>
    {{ !(account$ | async) || !(accountInCart$ | async) ? "add_shopping_cart" : "remove_shopping_cart" }}
</app-icon-button>

<egov-responsive-toolbar
    [buttons]="[
        { regularButton: addToCartButton, menuItem: addToCartMenuItem, menuItemGroup: 'cart' },
        (displayPrintBillButton$ | async) !== false ? { regularButton: printButton, menuItem: printMenuItem, menuItemGroup: 'print' } : null,
        (displayPrintBillButton$ | async) !== false ? { regularButton: licenseButton, menuItem: licenseMenuItem, menuItemGroup: 'print' } : null,
        (autoDraftEnabled$ | async) !== false ? { regularButton: autoDraftButton, menuItem: autoDraftMenuItem, menuItemGroup: 'track' } : null,
        (subscriptionsEnabled$ | async) !== false ? { regularButton: subscribeButton, menuItem: subscribeMenuItem, menuItemGroup: 'track' } : null,
        (watchListsEnabled$ | async) !== false ? { regularButton: watchButton, menuItem: watchMenuItem, menuItemGroup: 'track' } : null
    ]"
    [onlyMenu]="viewport.phone$ | async"
    [menuButton]="menuButton"
    [menuButtonEnabled]="(account$ | async) && (servicesInfoLoaded$ | async)"
    [style.flex-basis]="(viewport.phone$ | async) ? 0 : null"
>
    <ng-template #menuButton>
        <app-icon-button [placeholder]="showPlaceholders || (servicesInfoLoaded$ | async) !== true" title="More options" [moreIconAtTheEnd]="true">
            more_vert
        </app-icon-button>
    </ng-template>

    <ng-template #addToCartButton>
        <add-or-remove-from-cart-button
            [showPlaceholder]="showPlaceholders || !(servicesInfoLoaded$ | async)"
            [showRemove]="accountInCart$ | async"
            [updating]="updatingCartState$ | async"
            [egovTooltip]="(account$ | async)?.paymentBlocked ? paymentBlockedTooltip : null"
            [title]="(account$ | async)?.paymentBlocked ? '' : (addToOrRemoveFromCartTitle$ | async)"
            [disabled]="(accountIsPayable$ | async) === false"
            (addToCart)="toggleAccountInCart()"
            (removeFromCart)="toggleAccountInCart()"
        >
        </add-or-remove-from-cart-button>
    </ng-template>

    <ng-template #paymentBlockedTooltip>
        <div style="min-width: 220px; max-width: 350px" [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"></div>
    </ng-template>

    <ng-template #addToCartMenuItem>
        <button
            class="add-to-cart"
            mat-menu-item
            [appModal]="(account$ | async)?.paymentBlocked ? paymentBlockedTooltip : undefined"
            [disabled]="!(account$ | async)?.due.total"
            (click)="toggleAccountInCart()"
        >
            {{ (accountInCart$ | async) !== true ? "Add to Cart" : "Remove from Cart" }}
        </button>
    </ng-template>

    <ng-template #printButton>
        <ng-container *ngIf="!showPlaceholders && (servicesInfoLoaded$ | async); else printButtonPlaceholder">
            <div
                ><!-- Adding extra element because if condition is false and no element is projected, egov-responsivt-toolbar misbehaves -->
                <a *ngIf="(account$ | async)?.renewalNoticeUrl" class="print" [href]="(account$ | async)!.renewalNoticeUrl" target="_blank">
                    <button mat-button>
                        <span class="label">Renewal Notice</span>
                        <mat-icon class="right">description</mat-icon>
                    </button>
                </a>
            </div>
        </ng-container>
        <ng-template #printButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Renewal Notice</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #printMenuItem>
        <a class="print" *ngIf="(account$ | async)?.renewalNoticeUrl" mat-menu-item [href]="(account$ | async)?.renewalNoticeUrl" target="_blank">
            Renewal Notice
        </a>
    </ng-template>

    <ng-template #licenseButton>
        <ng-container *ngIf="!showPlaceholders && (servicesInfoLoaded$ | async); else licenseButtonPlaceholder">
            <div>
                <a *ngIf="(account$ | async)?.licenseUrl" class="license" [href]="(account$ | async)!.licenseUrl" target="_blank">
                    <button mat-button>
                        <span class="label">Print License</span>
                        <mat-icon class="right">description</mat-icon>
                    </button>
                </a>
            </div>
        </ng-container>
        <ng-template #licenseButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Print License</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #licenseMenuItem>
        <a *ngIf="(account$ | async)?.licenseUrl" class="license" mat-menu-item [href]="(account$ | async)?.licenseUrl" target="_blank"> Print License </a>
    </ng-template>

    <ng-template #autoDraftButton>
        <button
            *ngIf="!showPlaceholders && (servicesInfoLoaded$ | async); else autoDraftButtonPlaceholder"
            mat-button
            class="auto-draft"
            (click)="showAutoDraftDialog()"
        >
            <span class="label">Auto-Draft</span>
            <mat-icon class="right">event_available</mat-icon>
        </button>
        <ng-template #autoDraftButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Auto-Draft</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #autoDraftMenuItem>
        <button class="auto-draft" mat-menu-item (click)="showAutoDraftDialog()"> Auto-Draft </button>
    </ng-template>

    <ng-template #subscribeButton>
        <button
            *ngIf="!showPlaceholders && (servicesInfoLoaded$ | async); else subscribeButtonPlaceholder"
            mat-button
            class="subscriptions"
            (click)="showSubscriptionsDialog()"
        >
            <span class="label">Subscriptions</span>
            <mat-icon class="right">add_alert</mat-icon>
        </button>
        <ng-template #subscribeButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Subscriptions</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #subscribeMenuItem>
        <button class="subscriptions" mat-menu-item (click)="showSubscriptionsDialog()"> Subscriptions </button>
    </ng-template>

    <ng-template #watchButton>
        <button
            *ngIf="!showPlaceholders && (servicesInfoLoaded$ | async); else watchButtonPlaceholder"
            mat-button
            class="watch"
            title="Add or remove this account from watch lists"
            (click)="watchAccount()"
        >
            <span class="label">Watch</span>
            <mat-icon class="right">visibility</mat-icon>
        </button>
        <ng-template #watchButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Watch</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #watchMenuItem>
        <button mat-menu-item class="watch" (click)="watchAccount()"> Watch </button>
    </ng-template>
</egov-responsive-toolbar>
